import { motion } from 'framer-motion'
import { useSlideCopy } from '@/lib/i18n'
import { useLocale } from '@/lib/locale'
import type { SlideProps } from '@/components/SlideWizard'
import { copy } from './Slide6Document.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide6Document(_props: SlideProps) {
  const c = useSlideCopy(copy)
  // Rows slide in from the reading-direction start edge.
  const rtl = useLocale() === 'ar'
  const enterX = rtl ? 10 : -10

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 mx-auto max-w-3xl">
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1, ease }}
        className="text-xs sm:text-sm uppercase tracking-[0.25em] text-slate-400 font-semibold"
      >
        {c.eyebrow}
      </motion.p>

      <motion.h2
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.25, ease }}
        className="mt-4 text-4xl sm:text-5xl font-semibold text-slate-900 tracking-tight leading-[1.1]"
      >
        {c.title}
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.55, ease }}
        className="mt-8 text-xl sm:text-2xl text-slate-500 leading-relaxed max-w-xl"
      >
        {c.body}
      </motion.p>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.85, ease }}
        className="mt-10 w-full max-w-md text-start"
      >
        {c.items.map((item, i) => (
          <motion.div
            key={item}
            initial={{ opacity: 0, x: enterX }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: 0.95 + i * 0.12, ease }}
            className="flex items-start gap-3.5 py-2.5"
          >
            <svg
              className="mt-1 h-5 w-5 shrink-0 text-emerald-500"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M16.704 5.29a1 1 0 010 1.42l-7.25 7.25a1 1 0 01-1.42 0l-3.25-3.25a1 1 0 111.42-1.42L8.75 11.83l6.54-6.54a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span className="text-lg sm:text-xl text-slate-700 leading-snug">
              {item}
            </span>
          </motion.div>
        ))}
      </motion.div>

    </div>
  )
}
